import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Share, PlusSquare, CheckCircle2 } from "lucide-react";
import "./installPromptPage.css";
import MobileTopBar from "../../components/MobileTopBar";
import DesktopTopBar from "../../components/DesktopTopBar";
import dogHeadIcon from "../../assets/dogLevel2.png";

const InstallPromptPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const backPath = location.state?.from || "/app-tour-page";

  const continuePath = location.state?.from || "/onboarding-tutorial";

  const isFromHelpPage = location.state?.from === "/help";

  const handleBack = () => navigate(backPath);
  const handleContinue = () => navigate(continuePath);

  return (
    <div className="sp-install-page">
      {/* Top Bar */}
      <div className="sp-install-topbar">
        <MobileTopBar
          onBack={handleBack}
          backColor="#fff"
          logoColor="#fff"
          isProtectedRoute={false}
        />
        <DesktopTopBar
          showBack={true}
          onBack={handleBack}
          backColor="#fff"
          showProgress={false}
        />
      </div>

      {/* Main Content */}
      <div className="sp-install-content-wrapper">
        <div className="sp-install-content">
          <img
            src={dogHeadIcon}
            alt="Dog Icon"
            className="sp-install-dog-icon"
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />

          <h1 className="sp-install-title">
            ADD SOCIAL PAWS TO YOUR
            <br />
            HOME SCREEN!
          </h1>

          <p className="sp-install-subtitle">
            To get all the benefits of an app out of our webapp! Here’s how:
          </p>

          <div className="sp-install-steps-card">
            <div className="sp-install-step">
              <div className="sp-step-number">1</div>
              <p className="sp-step-text">
                Tap the Share Button on your browser
              </p>
              <Share className="sp-step-icon" size={24} />
            </div>

            <div className="sp-install-step">
              <div className="sp-step-number">2</div>
              <p className="sp-step-text">
                Find and Choose “Add to Home Screen”
              </p>
              <PlusSquare className="sp-step-icon" size={24} />
            </div>

            <div className="sp-install-step">
              <div className="sp-step-number">3</div>
              <p className="sp-step-text">
                Tap “Add” and Social Paws is there for you next time
              </p>
              <CheckCircle2 className="sp-step-icon" size={24} />
            </div>

            <div className="sp-install-step">
              <div className="sp-step-number">4</div>
              <p className="sp-step-text">
                Then, come right back here to this browser - to pick up where
                you left off.
              </p>
              <CheckCircle2 className="sp-step-icon" size={24} />
            </div>
          </div>

          <button className="sp-install-primary-btn" onClick={handleContinue}>
            GOT IT
          </button>

          {!isFromHelpPage && (
            <button
              className="sp-install-secondary-btn"
              onClick={handleContinue}
            >
              Remind me later
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InstallPromptPage;
